// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JEbY","tabsBox":"styles_tabsBox__TXkA-","createButton":"styles_createButton__29Ots"};